import React from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import StrategyPage from '../components/legendary/StrategyPage';

export default function LegendaryONeil() {
  return (
    <StrategyPage
      strategyKey="ONEIL"
      title="O'Neil CAN SLIM"
      icon={<AutoAwesomeIcon />}
      color="#3b82f6"
    />
  );
}
